module.exports = __webpack_public_path__ + "img/nomad8.379327a4.jpg";